import React from 'react'
import { MicrophoneActivity, useToggleLocalMute } from 'amazon-chime-sdk-component-library-react'
import Fab from '@mui/material/Fab'
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined'
import MicOffOutlinedIcon from '@mui/icons-material/MicOffOutlined'
import ControlBarItem from './ControlBarItem'

type AudioInputControlProps = {
  attendeeId?: string
}

export default function AudioInputControl(props: AudioInputControlProps) {
  const { muted, toggleMute } = useToggleLocalMute()

  if (!props.attendeeId)
    return (
      <ControlBarItem>
        <Fab color="primary" onClick={toggleMute} size="small">
          {muted ? <MicOffOutlinedIcon /> : <MicNoneOutlinedIcon />}
        </Fab>
      </ControlBarItem>
    )

  return (
    <ControlBarItem>
      <Fab color="primary" onClick={toggleMute} size="small">
        <MicrophoneActivity attendeeId={props.attendeeId} />
      </Fab>
    </ControlBarItem>
  )
}
